<template>
    <svgImage :name="`pricing-discount-${this.lang}`" />
</template>

<script>
import svgImage from '../../common/VueComponents/VueIcon/vgpSvgImage.vue';
export default ({
    components: {
        svgImage
    },
    data() {
        return {
            lang: window.lang.lang,
        }
    },
    methods: {
    },
})
</script>
